import { render, staticRenderFns } from "./ProposalsList.vue?vue&type=template&id=6b880550&scoped=true&"
import script from "./ProposalsList.vue?vue&type=script&lang=js&"
export * from "./ProposalsList.vue?vue&type=script&lang=js&"
import style0 from "./ProposalsList.vue?vue&type=style&index=0&id=6b880550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b880550",
  null
  
)

export default component.exports